<template>
  <div>
    <PageTitle v-bind:title="title" v-bind:admin="false" />

    <!-- <SlidersTest /> -->

    <div class="alert alert-danger" v-if="errors.load">
      {{ errors.load }}
    </div>
    <Loader v-if="loading" />
    <div v-else-if="data.user.id" class="my-5">
      <div class="row my-5 p-5">
        <div class="col-12 col-md-4">

            <span
              v-if="data.user.is_author"
              class="badge badge-success user-profile__badge"
              >Автор</span
            >
            <span
              v-if="data.user.is_admin"
              class="badge badge-danger user-profile__badge"
              >Администратор</span
            >
            <img
              :src="data.user.userphoto"
              class="d-block mx-auto w-75 rounded-lg"
              style="opacity: 0.9"
              alt=""
            />


          <div class="text-center my-4">
            <h4>{{ data.user.fullname }}</h4>
          </div>
          <div class="text-center my-4">
            <p>{{ data.user.description }}</p>
          </div>
        </div>
        <div class="col-12 col-md-8">
          <p v-if="data.user.is_author" class="text-center text-md-left">
            <strong>Кол-во курсов:</strong> {{ data.user.courses.length }}
          </p>

          <p class="text-center text-md-left">
            <strong>Дата регистрации:</strong> {{ localeDate }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import Loader from "@/components/Loader";
import PageTitle from "@/components/PageTitle";
// import SlidersTest from '@/components/SlidersTest'

//import jQuery from 'jquery'
export default {
  data() {
    return {
      loading: true,
      data: [],
      errors: { load: "" },
      title: "Информация о пользователе",
    };
  },
  async mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.errors.load = "";
      try {
        this.loading = true;
        let response = await axios.get("users/" + this.$route.params.id);
        this.data = response.data;
        this.loading = false;
      } catch (e) {
        this.errors.load = "Ошибка при загрузке данных";
      }
    },
  },

  computed: {
    localeDate() {
      // Конвертируем число в строку. Для этого существуют специальные методы
      // toLocaleDateString() или toLocaleString() или toLocaleTimeString()
      // Итоговая строка будет зависеть от локализации системы пользователя.
      // Для русской локали это будет "01.02.2020",
      // для американской "2/1/2020",
      // для немецкой — "1.2.2020"
      // Вы НЕ должны устанавливать формат даты самостоятельно
      return new Date(this.data.user.created_at).toLocaleDateString();
    },
  },

  components: {
    Loader,
    PageTitle,
    // SlidersTest
  },
};
</script>

<style scoped>
.user-profile__badge {
  z-index: 100;
  position: absolute;
  top: 10px;
  right: 10%;
}
</style>